import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, getUserNameToName, formatData, isNullOrEmpty } from '../../../../../../utils/util';
import { Breadcrumbs, Button, Input, Label } from '../../../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../../../services/LinePickingService';
import { onValueChange, validateInputsRequired } from '../../../../../../utils/handleChangeHooks';
import ModalUpload from './ModalUpload';

const Insert = (props) => {
    const update = props.location?.state?.update;
    const [openModal, setOpenModal] = useState(false)
    const [formUseModel, setFormUseModel] = useState({
        use: '',
        model: ''
    })
    const [partnumber, setPartnumber] = useState(props.location?.state?.update && props.partnumber
        ? props.partnumber : {
            partNumber: '',
            use: '',
            model: '',
            listUseModel: []
        });

    const onChange = (event) => {
        if (update) {
            onValueChange(event, partnumber, setPartnumber);
        } else {
            onValueChange(event, formUseModel, setFormUseModel);
        }
    };

    const addUseModelList = () => {
        if (!isNullOrEmpty(formUseModel.use) && !isNullOrEmpty(formUseModel.model)) {
            if (partnumber.listUseModel.find(f => f.use === formUseModel.use && f.model === formUseModel.model)) {
                return showMessageToastCustom(translate('warning', 'general'), "Item já adicionado!.", 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                partnumber.listUseModel.push({ use: formUseModel.use, model: formUseModel.model });
                partnumber.model = formUseModel.model;
                partnumber.use = formUseModel.use;
                partnumber.partNumber = formUseModel.partNumber;
                setPartnumber({ ...partnumber });
                formUseModel.model = "";
                formUseModel.use = "";
                setFormUseModel({ ...formUseModel });
            }
        }
    }

    const removeUseModelList = (item) => {
        partnumber.listUseModel = partnumber.listUseModel?.filter((i) => i.use !== item.use && i.model !== item.model);
        setPartnumber({ ...partnumber });
    }


    const onConfirm = () => {
        if (validateInputsRequired("formInsert")) {
            if (update) {
                props.partnumberUpdate(partnumber, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        props.history.go(-1);
                    }
                });
            } else {
                if (partnumber.listUseModel.length > 0) {
                    props.partnumberInsert(partnumber, (response) => {
                        if (!response) {
                            showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                        } else {
                            showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                            props.history.go(-1);
                        }
                    });
                }
            }
        }
    };

    const titleMovementType = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.partnumbers', 'configuration') };
    const subtitlesMovementType = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-repeat", label: translate('partnumber', 'stock') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="partnumberinsert" title={titleMovementType} subtitles={subtitlesMovementType()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formInsert">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            required
                                            placeholder={translate('stock:partnumber')}
                                            type="text"
                                            defaultValue={partnumber?.partNumber || ''}
                                            onChange={onChange}
                                            length={11}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <Input
                                            required={update}
                                            id="use"
                                            name='use'
                                            placeholder={'Uso'}
                                            type="text"
                                            value={update ? partnumber?.use || '' : formUseModel.use}
                                            onChange={onChange}
                                            length={10}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            required={update}
                                            id="model"
                                            name="model"
                                            type="text"
                                            label={'Modelo'}
                                            onChange={onChange}
                                            value={update ? partnumber?.model || '' : formUseModel.model}
                                            length={30}
                                        />
                                    </div>
                                    {
                                        !update && <div className="input-field no-padding  col s1">
                                            <button
                                                className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                                type="button"
                                                onClick={() => addUseModelList(true)}>
                                                <i className="Small material-icons">add</i>
                                            </button>
                                        </div>
                                    }
                                    <div className="input-field no-padding  col s1">
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => setOpenModal(true)}>
                                            <i className="Small material-icons">cloud_upload</i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                {
                                    partnumber.listUseModel && partnumber.listUseModel.length > 0 &&
                                    partnumber.listUseModel.map((item, index) => (
                                        <div key={item.use + index} className="no-padding col s12">
                                            <div key={item.use + 1} className="list sixth-text-color">
                                                <i onClick={() => removeUseModelList(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                                {`${item.use} - ${item.model}`}
                                            </div>
                                        </div>
                                    ))
                                }
                                <div>
                                    {update &&
                                        <>
                                            <Label label={translate('fields.updateBy', 'movement-type')} id="updateBy" value={getUserNameToName(props?.usersFromElog, partnumber?.updatedBy)} />
                                            <Label label={translate('fields.updateOn', 'movement-type')} id="updateOn" value={formatData(partnumber?.updatedOn)} />
                                        </>
                                    }
                                    <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                    <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <ModalUpload
                open={openModal}
                id="ModalUploadPartnumbers"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        partnumber: state.linePickingReducer.partnumberUseModel,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        partnumberInsert: (partnumber, callback) => {
            dispatch(LinePickingService.addPartnumberUseModel(partnumber, callback));
        },
        partnumberUpdate: (partnumber, callback) => {
            dispatch(LinePickingService.editPartnumberUseModel(partnumber, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Insert)));
